import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Chip } from '@mui/material';
import FilterTable from '../../../../atoms/TableComponent/FilterTable/FilterTable';
import axiosInstance from '../../../../lib/axios';
import { toast } from 'react-toastify';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';

export default function YojnaAlocationtable() {
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const permissions = usePermissions("Yojana Allocate to SubStation");
    const { AddRec = "0" } = permissions || {};
    const globalProperty = useSelector(selectGlobalProperty);

    useEffect(() => {
        fetchData();
    }, [globalProperty]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post('MstYojana/GetMstYojanaWiseHkWrkAreaDashBoard',
                {
                    start: 1,
                    PageSize: 1,
                    SearchText: globalProperty
                }
            );
            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(hkTask => ({
                    ...hkTask,
                    YojanaName: hkTask.YojanaName || '',
                    PropName: hkTask.PropName || '',
                    Shift: hkTask.Shift || '',
                    Status: hkTask.Status == null ? '' : (hkTask.Status == 1 ? 'Active' : 'Inactive'),
                }));
                setRows(formattedData);
            } else {
                setRows([]);
            }
        } catch (error) {
            toast.error('Error while fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            handleClick();
        }
    };

    const handleClick = () => {
        navigate('/yojana-alocation', { state: { mode: "add" } });
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationclick = () => {
        navigate('/masters/operations');
    };

    const handleRowDoubleClick = (params) => {
        const row = params?.data;
        if (!row?.YojanaId || !row?.PropId || !row?.ShiftId) return;

        navigate('/yojana-alocation', {
            state: {
                YojanaId: row.YojanaId,
                PropId: row.PropId,
                ShiftId: row.ShiftId,
                mode: 'view'
            }
        });
    };

    const TruncatedCellRenderer = (props) => {
        const [isOverflowed, setIsOverflowed] = useState(false);
        const cellRef = React.useRef(null);

        useEffect(() => {
            if (cellRef.current) {
                const isTextOverflowed =
                    cellRef.current.scrollWidth > cellRef.current.clientWidth ||
                    (props.value && props.value.length > 20);
                setIsOverflowed(isTextOverflowed);
            }
        }, [props.value]);

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        return (
            <div
                ref={cellRef}
                className="truncated-cell"
                style={{ width: '100%' }}
            >
                {cellValue}
            </div>
        );
    };

    const StatusCellRenderer = (props) => {
        const getStatusColor = (status) => {
            switch (status) {
                case 'Active':
                    return '#4caf50';
                case 'Inactive':
                    return '#f44336';
                default:
                    return '#f44336';
            }
        };

        return (
            <Chip
                label={props.value}
                className="status-chip"
                sx={{
                    backgroundColor: getStatusColor(props.value),
                    color: 'white',
                    width: '100%',
                    maxWidth: '100px',
                }}
            />
        );
    };

    const columnDefs = [
        { headerName: 'Sr.No.', field: 'RowNum', width: 60, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Yojana Name', field: 'YojanaName', minWidth: 250, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Property', field: 'PropName', minWidth: 150, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Shift', field: 'ShiftName', minWidth: 250, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Status', field: 'Status', width: 100, filter: 'agTextColumnFilter', cellRenderer: StatusCellRenderer },
    ];

    return (
        <Box sx={{ height: '90vh' }}>
            <FilterTable
                columnDefs={columnDefs}
                rowData={rows}
                onRowDoubleClicked={handleRowDoubleClick}
                isLoading={isLoading}
                onHomeClick={handleHomeClick}
                onParentClick={handleLocationclick}
                breadcrumbParentLabel="Operations"
                breadcrumbCurrentLabel="Yojana Allocation"
                onAddClick={handlePermittedClick}
                hasAddPermission={AddRec === "1"}
            />
        </Box>
    );
}
